var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 5.72998C18.9802 5.72998 18.9502 5.72998 18.9202 5.72998C13.6302 5.19998 8.35016 4.99998 3.12016 5.52998L1.08016 5.72998C0.66016 5.76998 0.29016 5.46998 0.25016 5.04998C0.21016 4.62998 0.51016 4.26998 0.92016 4.22998L2.96016 4.02998C8.28016 3.48998 13.6702 3.69998 19.0702 4.22998C19.4802 4.26998 19.7802 4.63998 19.7402 5.04998C19.7102 5.43998 19.3802 5.72998 19.0002 5.72998Z",
    fill: "#B2AEBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49977 4.72C6.45977 4.72 6.41977 4.72 6.36977 4.71C5.96977 4.64 5.68977 4.25 5.75977 3.85L5.97977 2.54C6.13977 1.58 6.35977 0.25 8.68976 0.25H11.3098C13.6498 0.25 13.8698 1.63 14.0198 2.55L14.2398 3.85C14.3098 4.26 14.0298 4.65 13.6298 4.71C13.2198 4.78 12.8298 4.5 12.7698 4.1L12.5498 2.8C12.4098 1.93 12.3798 1.76 11.3198 1.76H8.69977C7.63977 1.76 7.61977 1.9 7.46977 2.79L7.23977 4.09C7.17977 4.46 6.85977 4.72 6.49977 4.72Z",
    fill: "#B2AEBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2099 21.7501H6.7899C3.2999 21.7501 3.1599 19.8201 3.0499 18.2601L2.3999 8.19007C2.3699 7.78007 2.6899 7.42008 3.0999 7.39008C3.5199 7.37008 3.8699 7.68008 3.8999 8.09008L4.5499 18.1601C4.6599 19.6801 4.6999 20.2501 6.7899 20.2501H13.2099C15.3099 20.2501 15.3499 19.6801 15.4499 18.1601L16.0999 8.09008C16.1299 7.68008 16.4899 7.37008 16.8999 7.39008C17.3099 7.42008 17.6299 7.77007 17.5999 8.19007L16.9499 18.2601C16.8399 19.8201 16.6999 21.7501 13.2099 21.7501Z",
    fill: "#B2AEBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6601 16.25H8.33008C7.92008 16.25 7.58008 15.91 7.58008 15.5C7.58008 15.09 7.92008 14.75 8.33008 14.75H11.6601C12.0701 14.75 12.4101 15.09 12.4101 15.5C12.4101 15.91 12.0701 16.25 11.6601 16.25Z",
    fill: "#B2AEBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.25H7.5C7.09 12.25 6.75 11.91 6.75 11.5C6.75 11.09 7.09 10.75 7.5 10.75H12.5C12.91 10.75 13.25 11.09 13.25 11.5C13.25 11.91 12.91 12.25 12.5 12.25Z",
    fill: "#B2AEBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete_2.2d29c152.svg";
export { ForwardRef as ReactComponent };